export const SCHEMA_NAME = "Businesses";

export const FIELDS = {
  BUSINESS_ID: "businessID",
  ADDRESS_ID: "addressID",
  TYPE_OF_OWNERSHIP: "typeOfOwnership",
  BUSINESS_NAME: "businessName",
  BUSINESS_MANAGEMENT_ID: "businessManagementID",
  BUSINESS_MANAGER: "businessManager",
  BUSINESS_PHONE: "businessPhone",
  BUSINESS_FAX: "businessFax",
};
